"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@veeam/core");
var FormLayout_1 = require("../../FormLayout");
var StackView_1 = require("../../StackView");
var Dialog_1 = require("../../Dialog");
var DateField_1 = require("../../fields/DateField");
var RadioField_1 = require("../../fields/RadioField");
var DatePeriodMenuInteractor_1 = require("./DatePeriodMenuInteractor");
var FilterMenu_1 = require("../../FilterMenu");
var helpers_1 = require("../../helpers");
exports.DatePeriodMenu = helpers_1.createUIElement('DatePeriodMenu', function (_a, ref) {
    var className = _a.className, texts = _a.texts, _b = _a.value, value = _b === void 0 ? [] : _b, startDatetime = _a.startDatetime, endDatetime = _a.endDatetime, defaultInitDate = _a.defaultInitDate, defaultInitFromDate = _a.defaultInitFromDate, defaultInitToDate = _a.defaultInitToDate, onDone = _a.onDone, onCancel = _a.onCancel, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "texts", "value", "startDatetime", "endDatetime", "defaultInitDate", "defaultInitFromDate", "defaultInitToDate", "onDone", "onCancel", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var _c = core_1.useInteractor(function () {
        return new DatePeriodMenuInteractor_1.DatePeriodMenuInteractor(value, { onSubmit: onDone }, {
            defaultInitDate: defaultInitDate,
            defaultInitFromDate: defaultInitFromDate,
            defaultInitToDate: defaultInitToDate
        });
    }).interactor, form = _c.form, didApplySelect = _c.didApplySelect;
    var typeValue = core_1.useField(form.fields.type).control.value;
    var startDate = core_1.useField(form.fields.startDate).control.value;
    var endDate = core_1.useField(form.fields.endDate).control.value;
    return (react_1.default.createElement(FilterMenu_1.FilterMenuBody, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-DatePeriodMenu " + className, title: (texts === null || texts === void 0 ? void 0 : texts.title) || 'Specify time period', actions: [
            {
                text: (texts === null || texts === void 0 ? void 0 : texts.applyButton) || 'Apply',
                onClick: didApplySelect
            },
            {
                text: (texts === null || texts === void 0 ? void 0 : texts.cancelButton) || 'Cancel',
                view: Dialog_1.ACTION_VIEW.secondary,
                onClick: onCancel
            }
        ], onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(FormLayout_1.FormLayout, { inlineLabel: true },
            react_1.default.createElement(FormLayout_1.LabelGroup, { label: react_1.default.createElement(RadioField_1.RadioField, { disabled: typeValue != 'all', value: 'all', field: form.fields.type, label: (texts === null || texts === void 0 ? void 0 : texts.allTimeLabel) || 'All Time' }) }),
            react_1.default.createElement(FormLayout_1.LabelGroup, { label: react_1.default.createElement(RadioField_1.RadioField, { value: 'date', field: form.fields.type, label: (texts === null || texts === void 0 ? void 0 : texts.dateLabel) || 'Date' }) },
                react_1.default.createElement(DateField_1.DateField, { field: form.fields.date, disabled: typeValue != 'date', startDatetime: startDatetime, endDatetime: endDatetime })),
            react_1.default.createElement(FormLayout_1.LabelGroup, { hasTopOffset: true, label: react_1.default.createElement(RadioField_1.RadioField, { value: 'period', field: form.fields.type, label: (texts === null || texts === void 0 ? void 0 : texts.periodLabel) || 'Period' }) },
                react_1.default.createElement(FormLayout_1.FormLayout, { direction: StackView_1.STACK_DIRECTION.row, inlineLabel: false, disabled: typeValue != 'period' },
                    react_1.default.createElement(DateField_1.DateField, { field: form.fields.startDate, label: (texts === null || texts === void 0 ? void 0 : texts.fromLabel) || 'From', startDatetime: startDatetime, endDatetime: endDate || endDatetime || undefined }),
                    react_1.default.createElement(DateField_1.DateField, { startDatetime: startDate || startDatetime || undefined, endDatetime: endDatetime, field: form.fields.endDate, label: (texts === null || texts === void 0 ? void 0 : texts.endLabel) || 'To' }))))));
});
//# sourceMappingURL=DatePeriodMenu.js.map